import {StyleSheet} from 'react-native';
import {FontSizes, isPhone} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';

export const styles = StyleSheet.create({
  container: {
    width: '99%',
    borderRadius: 12,
    backgroundColor: CCColors?.DashboardBanner?.Background,
    overflow: 'hidden',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: '8%',
    paddingTop: 20,
    minHeight: 160,
    position: 'relative',
    margin: 8,
  },
  mobileContainer: {
    width: '100%',
    borderRadius: 12,
    backgroundColor: CCColors?.DashboardBanner?.Background,
    overflow: 'hidden',
    position: 'relative',
    paddingVertical: 16,
    paddingLeft: 16,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  leftContent: {
    flex: 1,
    justifyContent: 'center',
  },
  mobileLeftContent: {
    width: '100%',
  },
  logoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  mobileLogoContainer: {
    justifyContent: 'space-between',
    width: '100%',
    paddingRight: 16,
  },
  logo: {
    width: isPhone ? 108 : 126,
    height: isPhone ? 24 : 28,
    resizeMode: 'contain',
  },
  title: {
    color: CCColors?.White,
    fontWeight: '700',
    marginBottom: 8,
  },
  mobileTitle: {
    fontSize: FontSizes[18],
  },
  tagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 15,
  },
  tag: {
    color: CCColors?.White,
    fontSize: FontSizes[14],
    fontWeight: '500',
  },
  mobileTag: {
    fontSize: FontSizes[12],
  },
  tagSeparator: {
    color: CCColors?.White,
    marginHorizontal: isPhone ? 4 : 8,
  },
  bottomRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 24,
    marginTop: 10,
    marginBottom: 23,
  },
  mobileBottomRow: {
    flexWrap: 'wrap',
    marginTop: 20,
    width: '70%',
  },
  btnText: {
    color: CCColors?.DashboardBanner?.CtaText,
    fontWeight: '800',
    fontSize: FontSizes[14],
  },
  offerContainer: {
    flexDirection: 'column',
  },
  upToText: {
    color: CCColors?.DashboardBanner?.offerYellow,
    fontSize: FontSizes[12],
    fontWeight: '700',
  },
  offText: {
    color: CCColors?.DashboardBanner?.offerYellow,
    fontSize: FontSizes[24],
    fontWeight: '800',
  },
  couponContainer: {
    backgroundColor: CCColors?.White,
    borderWidth: 1,
    borderColor: CCColors?.OnboardingGrey,
    borderRadius: 6,
    padding: 2,
  },
  couponContainerInner: {
    backgroundColor: '#FFF5DC',
    borderWidth: 1,
    borderColor: '#26232233',
    borderStyle: 'dashed',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    borderRadius: 4,
    paddingVertical: 4,
    paddingHorizontal: 5,
  },
  couponText: {
    color: CCColors?.TextColor?.Dark,
    fontSize: FontSizes[14],
    fontWeight: '700',
    letterSpacing: 0.5,
  },
  girlImage: {
    width: 342,
    height: '100%',
  },
  mobileGirlImage: {
    width: 127,
    height: 119,
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
});
